import React, { useState } from "react";
import { Box, Flex, Text, IconButton } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon, CloseIcon } from "@chakra-ui/icons";

const MessageTemplatePlaceholdersModal = ({ textAreaRef, placeholders, onEdit, isCollapsible }) => {
  const [isExtended, setIsExtended] = useState(true);

  const toggleModalSize = () => {
    setIsExtended(!isExtended);
  };

  return (
    <Box p={4} width="100%" height="auto" overflow="auto" >
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontSize="xl" fontWeight="bold">Placeholders</Text>
        {isCollapsible && (
          <IconButton
            icon={isExtended ? <ChevronUpIcon/> : <ChevronDownIcon/>}
            onClick={toggleModalSize}
            aria-label={isExtended ? "Collapse" : "Extend"}
            variant="ghost"
            size="sm"
          />
        )}
        {!isCollapsible && (
          <IconButton
            icon={<CloseIcon/>}
            aria-label="Close without saving"
            variant="ghost"
            size="sm"
          />
        )}
      </Flex>
      {isExtended && (
        <Box textAlign="left">
          {placeholders.map((ph, index) => (
            <Box
              key={index}
              p={2}
              borderBottom="1px solid"
              borderColor="gray.200"
              cursor="pointer"
              _hover={{ backgroundColor: "gray.100" }}
              onMouseDown={(e) => {
                e.preventDefault();

                const textarea = textAreaRef.current;
                if (!textarea) return;

                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const text = textarea.value || "";

                const before = text.substring(0, start);
                const after = text.substring(end);
                const newText = before + ph.placeholder + after;

                onEdit(newText);

                setTimeout(() => {
                  textarea.focus();
                  textarea.selectionStart = start + ph.placeholder.length;
                  textarea.selectionEnd = start + ph.placeholder.length;
                }, 0);
              }}
            >
              <Text fontWeight="bold">{ph.placeholder}</Text>
              <Text>{ph.meaning}</Text>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default MessageTemplatePlaceholdersModal;
